import { render } from "./OnboardingLayout.vue?vue&type=template&id=456bf40a&scoped=true"
import script from "./OnboardingLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingLayout.vue?vue&type=script&lang=js"

import "./OnboardingLayout.vue?vue&type=style&index=0&id=456bf40a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456bf40a"]])

export default __exports__